/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'

const $nsid = 'com.atproto.server.describeServer'

type $nsid = typeof $nsid

export { $nsid }

export const $params = /*#__PURE__*/ l.params()

export type $Params = l.InferOutput<typeof $params>

export const $output = /*#__PURE__*/ l.jsonPayload({
  did: /*#__PURE__*/ l.string({ format: 'did' }),
  links: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.ref<Links>((() => links) as any),
  ),
  contact: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.ref<Contact>((() => contact) as any),
  ),
  inviteCodeRequired: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.boolean()),
  availableUserDomains: /*#__PURE__*/ l.array(/*#__PURE__*/ l.string()),
  phoneVerificationRequired: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.boolean(),
  ),
})

export type $Output<B = l.BinaryData> = l.InferPayload<typeof $output, B>
export type $OutputBody<B = l.BinaryData> = l.InferPayloadBody<
  typeof $output,
  B
>

/** Describes the server's account creation requirements and capabilities. Implemented by PDS. */
const main = /*#__PURE__*/ l.query($nsid, $params, $output)

export { main }

const $lxm = $nsid

type $lxm = typeof $lxm

export { $lxm }

type Links = {
  $type?: 'com.atproto.server.describeServer#links'
  privacyPolicy?: l.UriString
  termsOfService?: l.UriString
}

export type { Links }

const links = /*#__PURE__*/ l.typedObject<Links>(
  $nsid,
  'links',
  /*#__PURE__*/ l.object({
    privacyPolicy: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string({ format: 'uri' }),
    ),
    termsOfService: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string({ format: 'uri' }),
    ),
  }),
)

export { links }

type Contact = {
  $type?: 'com.atproto.server.describeServer#contact'
  email?: string
}

export type { Contact }

const contact = /*#__PURE__*/ l.typedObject<Contact>(
  $nsid,
  'contact',
  /*#__PURE__*/ l.object({
    email: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
  }),
)

export { contact }
